var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1667 2.83334H2.57576C1.27184 2.83334 0 4.12122 0 5.48959V28.5909C0 29.8949 1.28788 31.1667 2.57576 31.1667H14.1667V29.8788H2.57576C1.93182 29.8788 1.28788 29.2349 1.28788 28.5909V5.4091C1.28788 4.76516 1.93182 4.12122 2.57576 4.12122H14.1667V2.83334ZM14.1667 5.4091H3.86364C3.2197 5.4091 2.57576 6.05304 2.57576 6.69698V24.7273L11.5909 14.4243L14.1667 17.8586V5.4091Z",
    fill: "current"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.1667,
    width: 2.83333,
    height: 34,
    rx: 0.5,
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 31.1667H31.4242C32.712 31.1667 33.9999 29.8949 33.9999 28.5909V5.4091C33.9999 4.12122 32.7281 2.83334 31.4242 2.83334H19.8333V4.12122H31.4242C32.0681 4.12122 32.712 4.76516 32.712 5.4091V28.5909C32.712 29.2349 32.0681 29.8788 31.4242 29.8788H19.8333V31.1667Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8518 27.7719C30.604 28.0841 30.227 28.3047 29.8501 28.3047H19.8333L19.8333 20.1481L19.8333 17.787L22.1228 15.4259L29.8501 23.1532L30.8518 24.0833C30.8518 23.8321 30.8518 24.8704 30.8518 24.8704V27.7719Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1133 8.34259C27.1133 9.8096 25.9241 10.9988 24.4571 10.9988C22.9901 10.9988 21.8008 9.8096 21.8008 8.34259C21.8008 6.87559 22.9901 5.68634 24.4571 5.68634C25.9241 5.68634 27.1133 6.87559 27.1133 8.34259Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/Compare.38e3875e709c3778cc9f21e15f489b13.svg";
export { ForwardRef as ReactComponent };